import { mat4, mat3 } from "gl-matrix";

export class Util {

    constructor(private identityResolver: (identity: number) => any) {

    }

    public readIdentityList<T>(dataView: DataView, offset: number) {
        let length = dataView.getInt32(offset, true);
        offset += 4;

        let items = new Array<T>();

        for (let i = 0; i < length; i++) {
            let identity = dataView.getInt32(offset, true);
            offset += 4;

            items.push(this.identityResolver(identity) as T);
        }

        return {
            offset: offset,
            items: items
        };
    }

    public readStrings(dataView: DataView, offset: number) {
        let length = dataView.getInt32(offset, true);
        offset += 4;

        let strings = [];

        for (let i = 0; i < length; i++) {
            let stringResult = this.readString(dataView, offset);
            strings.push(stringResult.string);
            offset = stringResult.offset;
        }

        return {
            offset: offset,
            strings: strings
        };
    }

    public readString(dataView: DataView, offset: number) {

        let length = dataView.getInt32(offset, true);
        offset += 4;

        let byteArray = new Uint8Array(dataView.buffer, dataView.byteOffset + offset, length);

        return {
            offset: offset + length,
            string: this.utf8ByteArrayString(byteArray)
        };
    }

    public readFloatList(dataView: DataView, offset: number) {
        let length = dataView.getInt32(offset, true);
        offset += 4;

        let alignedBuffer = dataView.buffer.slice(dataView.byteOffset + offset, dataView.byteOffset + offset + length * 4);
        let floats = new Float32Array(alignedBuffer);
        return {
            offset: offset + length * 4,
            floats: floats,
            mat4: () => floats as mat4,
            mat3: () => floats as mat3
        };
    }

    public readIntList(dataView: DataView, offset: number) {
        let length = dataView.getInt32(offset, true);
        offset += 4;

        let alignedBuffer = dataView.buffer.slice(dataView.byteOffset + offset, dataView.byteOffset + offset + length * 4);

        return {
            offset: offset + length * 4,
            ints: new Int32Array(alignedBuffer)
        };
    }

    private utf8ByteArrayString(byteArray: Uint8Array): string {
        // Dirty hack from https://stackoverflow.com/questions/17191945/conversion-between-utf-8-arraybuffer-and-string
        let encodedString = String.fromCharCode.apply(null, byteArray);
        return decodeURIComponent(encodedString); // TODO: what did escape do here?
    }
}
